import React, { memo } from 'react'
import { Icon, Text } from 'common-components'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import CrownIcon from 'assets/svgr-icons/Crown.svg'
import { CapabilityChips } from 'containers/SubSidebar/shared/GroupedModelDropdown'
import RatingDots from '../RatingDots'
import CreditChip from '../CreditChip'
import InfoTooltip from './InfoTooltip'
import { IVideoDropdownModel } from '../types'
import * as Styled from './styled'

interface IVideoVariantRowProps {
  model: IVideoDropdownModel
  isSelected: boolean
  onSelect: () => void
}

const VideoVariantRow: React.FC<IVideoVariantRowProps> = ({
  model,
  isSelected,
  onSelect
}) => {
  return (
    <Styled.SubmenuVariantWrapper
      data-testid={`video-model-variant-${model.selectKey}`}
      $isSelected={isSelected}
      onClick={onSelect}
    >
      <Styled.SubmenuVariantHeader>
        <Text
          type={isSelected ? 'subtitle' : 'h2'}
          color={isSelected ? 'secondaryDark' : 'secondarySemiDark'}
        >
          {model.name}
        </Text>
        <InfoTooltip description={model.description} rating={model.rating} />
        {model.isPremium && (
          <Icon icon={<CrownIcon />} customSize={14} color="goldDark" />
        )}
        {isSelected && (
          <Styled.SelectedCheck>
            <Icon icon={<CheckIcon />} size="medium" color="primaryDark" />
          </Styled.SelectedCheck>
        )}
      </Styled.SubmenuVariantHeader>
      <Styled.MetaRow>
        {model.rating !== null && <RatingDots score={model.rating} />}
        <CapabilityChips labels={model.capabilityLabels} />
        <CreditChip info={model.creditInfo} />
      </Styled.MetaRow>
    </Styled.SubmenuVariantWrapper>
  )
}

export default memo(VideoVariantRow)
